import React, {useState} from 'react';

import {useCurrentUserState} from 'app/current-user/api';

import {DisplayTeamNameAndDescription} from './DisplayTeamNameAndDescription';
import {EditTeamNameAndDescription} from './EditTeamNameAndDescription';

import type {TeamSerializedType} from 'sweet-types';

interface Props {
  team: TeamSerializedType;
}

export const TeamPageHeader = ({team}: Props): JSX.Element | null => {
  const [isEditMode, setEditMode] = useState(false);
  const {team_memberships: memberships, is_super_manager: isSuperManager} =
    useCurrentUserState().data!;

  const userCurrentTeamMemberships = memberships.filter(
    (membership) => membership.team === team.url
  );
  const showNotMemberMessage =
    userCurrentTeamMemberships.length === 0 && !isSuperManager;

  return (
    <div className="mb-3">
      {!isEditMode ? (
        <DisplayTeamNameAndDescription
          team={team}
          onClick={() => setEditMode(true)}
          showNotMemberMessage={showNotMemberMessage}
        />
      ) : (
        <EditTeamNameAndDescription
          teamId={team.id}
          name={team.name}
          description={team.description}
          teammateCanAssign={team.teammates_can_assign_task}
          handleClose={() => setEditMode(false)}
        />
      )}
    </div>
  );
};
